import type { FC } from 'react'

import { Th } from '@skytech/ui/Table/Th'
import { twMerge } from 'tailwind-merge'

import { Translation } from '@/components/i18n/Translation'
import { useSearchParamsByKey, useSortParams } from '@/hooks/searchParams'

import { DEFAULT_ORDER_TYPE } from '../consts'
import type { CommonOrderKeys } from '../types'

export const SubscriptionOrdersTHead: FC = () => {
  const [queryOrderType] = useSearchParamsByKey('type', DEFAULT_ORDER_TYPE)
  const [, { handleSort }] = useSortParams<CommonOrderKeys>()

  // if order type is not specified, default to 'porting'
  const isPorting = queryOrderType === 'porting' || !queryOrderType
  const isTermination = queryOrderType === 'termination'
  const isUpgrade = queryOrderType === 'upgrade'

  return (
    <thead>
      <tr>
        <Th id="id" onClick={handleSort} className="capitalize md:p-2 lg:p-2.5 xl:p-4">
          <Translation id="id" />
        </Th>

        <Th
          id="customer"
          onClick={handleSort}
          className="hidden capitalize min-[500px]:table-cell md:p-2 lg:p-2.5 xl:p-4"
        >
          <Translation id="customer" />
        </Th>

        <Th
          id="user"
          onClick={handleSort}
          className="hidden capitalize sm:table-cell md:p-2 lg:p-2.5 xl:p-4"
        >
          <Translation id="user" />
        </Th>

        <Th id="status" onClick={handleSort} className="capitalize md:p-2 lg:p-2.5 xl:p-4">
          <Translation id="status" />
        </Th>

        {isPorting && (
          <Th
            id="activationDate"
            onClick={handleSort}
            className="capitalize md:p-2 lg:p-2.5 xl:p-4"
          >
            <Translation id="activation" />
          </Th>
        )}

        {isTermination && (
          <>
            <Th className="hidden capitalize md:table-cell md:p-2 lg:p-2.5 xl:p-4">
              <Translation id="type" />
            </Th>
            <Th
              id="terminationDate"
              onClick={handleSort}
              className="capitalize md:p-2 lg:p-2.5 xl:p-4"
            >
              <Translation id="termination" />
            </Th>
          </>
        )}

        {isUpgrade && (
          <Th
            id="subscriptionServiceName"
            onClick={handleSort}
            className="hidden capitalize md:table-cell md:p-2 lg:p-2.5 xl:p-4"
          >
            <Translation id="product" />
          </Th>
        )}

        <Th
          id="orderDate"
          onClick={handleSort}
          className={twMerge(
            'hidden capitalize md:table-cell md:p-2 lg:p-2.5 xl:p-4',
            isUpgrade && 'table-cell'
          )}
        >
          <Translation id="created" />
        </Th>

        <Th
          id="orderUpdate"
          onClick={handleSort}
          className="hidden capitalize md:table-cell md:p-2 lg:p-2.5 xl:p-4"
        >
          <Translation id="updated" />
        </Th>
      </tr>
    </thead>
  )
}
